export const CHAT_LIST_UPDATE_EVENT = 'CHAT_LIST_UPDATE';
export const MAX_CHAT_HISTORY_COUNT = 10;
export const MAX_PINNED_CHAT_COUNT = 5;
export const MAX_SAVE_PERIOD = 10; // days
